import { Box, IconProps, Text } from '@betty/moonlight';
import { memo } from 'react';
import { links } from './NavBar.constants';
import { TabBarIcon } from '@betty/navigation';
import { useSelector } from '@betty/toolkit/state';
import { selectIsSourceOfFundsVisible } from '@betty/account/state';
import { Link, useLocation } from 'react-router';
import { useTranslation } from '@betty/i18n';
import { useTabBarVisibility } from './hooks/useTabBarVisibility';
import styles from './NavBar.module.css';

function NavBar() {
  const [t] = useTranslation('common');
  const location = useLocation();
  const path = location.pathname;

  const isSOFVisible = useSelector(selectIsSourceOfFundsVisible);

  const isTabBarVisible = useTabBarVisibility();

  return isTabBarVisible ? (
    <div className={styles.navbarWrapper}>
      <Box
        width={{
          desktop: 364,
          tablet: 364,
          mobile: '100%',
        }}
        padding={{
          desktop: 'space-200',
          tablet: 'space-200',
          mobile: 'space-0',
        }}
        backgroundColor="blackBackground"
        borderRadius={{
          desktop: 'radius-400',
          tablet: 'radius-400',
          mobile: 'radius-0',
        }}
        flexDirection="row"
        justifyContent="space-evenly"
        boxShadow={{
          desktop: '0px 32px 96px 0px #ffc700e5',
          tablet: '0px 32px 96px 0px #ffc700e5',
          mobile: undefined,
        }}
      >
        {links.map((link) => (
          <Box
            key={link.name}
            padding="space-200"
            alignItems="center"
            flexGrow={{
              desktop: 1,
              tablet: 1,
              mobile: 0,
            }}
          >
            <Link to={link.url} replace>
              <Box>
                {isSOFVisible && link.name === 'Account' && (
                  <Box
                    position="absolute"
                    right="space-300"
                    transform={'translateX(10px)'}
                    variant="gradient"
                    width={12}
                    height={12}
                    borderRadius="radius-full"
                    gradient="attentionBackground"
                  ></Box>
                )}
                <TabBarIcon
                  name={`${link.name}Tab` as IconProps['name']}
                  color={link.url === path ? undefined : 'darkSurfacePrimary'}
                  gradient={link.url === path ? 'accentBackground' : undefined}
                />
              </Box>
              <Text
                variant="body-s"
                {...(link.url === path
                  ? { gradient: 'darkSurfaceAccent' }
                  : { color: 'darkSurfacePrimary' })}
              >
                {t(link.name.toLowerCase())}
              </Text>
            </Link>
          </Box>
        ))}
      </Box>
    </div>
  ) : null;
}

export default memo(NavBar);
